import { MAX_READ_TIME, TAG_MATCH } from '@/utils/constants'

// Maps a stored per-collection filters object to the query params the siblings
// endpoint expects (same shape as the list query in getItems). `isCollection`
// gates the private-only isFavorite filter. Only defined filters are emitted, so
// this is safe for the public endpoint too (which doesn't accept resourceType /
// isFavorite — neither is ever set for public collections).
export function buildSiblingParams(filters, { isCollection }) {
  const readTime = [
    filters.readTime?.[0] || false,
    filters.readTime?.[1] >= MAX_READ_TIME ? false : filters.readTime?.[1],
  ]
  const isFavorite = !isCollection && filters.isFavorite
  const search = filters.search?.trim()

  return {
    sortBy: filters.sorting[0],
    asc: filters.sorting[1],
    tags: filters.tags,
    ...(filters.tagMatch === TAG_MATCH.ALL && { tagMatch: TAG_MATCH.ALL }),
    ...(filters.resourceType && { resourceType: filters.resourceType }),
    ...(isFavorite && { isFavorite }),
    ...(search?.length >= 2 && { search }),
    ...(readTime.some(Boolean) && { readTime }),
    ...(filters.languages?.length && { languages: filters.languages }),
    ...(filters.addedBy?.length && { addedBy: filters.addedBy }),
  }
}
